import { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
  Box,
  Button,
  Card,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  SwipeableDrawer,
} from '@mui/material';
import { AppliedFiltersCounter } from '@/packages/courses/components/applied-filters-counter';
import {
  CatalogList,
  useCatalogListData,
} from '@/packages/courses/components/catalog-list';
import { CatalogFiltersList } from '@/packages/courses/components/filters';
import { FilterTagCloud } from '@/packages/courses/components/filters/filter-tag-cloud';
import { HeaderTitle } from '@/packages/courses/components/header-title';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';

const iOS =
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

export const CatalogFiltersMobile = () => {
  const [openFilters, setOpenFilters] = useState(false);
  const { totalCount, isFetching } = useCatalogListData();
  const { schema } = useCatalogFilters();

  const tagCloudItem = schema.find((s) => s.type === 'tagCloud');
  const hasTagCloud =
    tagCloudItem &&
    tagCloudItem.type === 'tagCloud' &&
    tagCloudItem.filterIdsToDisplay?.length > 0;

  return (
    <>
      <Card
        elevation={2}
        square
        sx={{
          mb: 2,
          position: 'sticky',
          top: -1,
          zIndex: 1,
        }}
      >
        <Container disableGutters maxWidth={false} sx={{ px: 2, py: 1.5 }}>
          <Stack spacing={1.5}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={1}
            >
              <HeaderTitle loading={isFetching} totalCount={totalCount} />
              <Button variant="contained" onClick={() => setOpenFilters(true)}>
                Filtrar <AppliedFiltersCounter />
              </Button>
            </Stack>
            {hasTagCloud && (
              <FilterTagCloud
                {...tagCloudItem}
                filterIdsToDisplay={tagCloudItem.filterIdsToDisplay}
                filterIdsToReset={tagCloudItem.filterIdsToReset}
                scrollable
              />
            )}
          </Stack>
        </Container>
      </Card>

      <SwipeableDrawer
        anchor="bottom"
        open={openFilters}
        onClose={() => setOpenFilters(false)}
        onOpen={() => setOpenFilters(true)}
        disableBackdropTransition={!iOS}
        disableDiscovery={iOS}
        variant="temporary"
        PaperProps={{
          sx: {
            maxHeight: '85vh',
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
          },
        }}
      >
        <DialogTitle sx={{ px: 2, py: 1 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => setOpenFilters(false)}
          >
            Filtros
          </Button>
        </DialogTitle>
        <DialogContent dividers sx={{ px: 2, py: 1 }}>
          <CatalogFiltersList />
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1 }}>
          <Button
            fullWidth
            variant="contained"
            onClick={() => setOpenFilters(false)}
          >
            Ver resultados ({totalCount})
          </Button>
        </DialogActions>
      </SwipeableDrawer>

      <Box sx={{ pt: 0 }}>
        <CatalogList />
      </Box>
    </>
  );
};
